import * as React from 'react';
import { SVGProps } from 'react';

const IconPriceLabelStrokedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    <path d="M18.575 6.95a2.475 2.475 0 1 1 0 4.95 2.475 2.475 0 0 1 0-4.95Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.001 2A3 3 0 0 1 26 5v8.132a3 3 0 0 1-.878 2.12l-9.87 9.87-.111.107a3 3 0 0 1-4.019 0l-.112-.107-8.131-8.132-.107-.111a3 3 0 0 1 .107-4.131l9.868-9.87a3.002 3.002 0 0 1 1.825-.863L14.87 2h8.132ZM5 14.87 13.13 23l9.871-9.868V5h-8.132L5 14.87Z"
    />
  </svg>
);
export default IconPriceLabelStrokedSizeL;
